import id from './lang/en.json'

export const lang = id